import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";

import { FieldRenderer, SelectCalendarFilter } from "../../App/components/CustomFields";
import {
  getTimeStampFromDateRange,
  removeEmptyObjects,
  getDateRanges,
  convertToOptions,
  getSelectedSensorParameters,
} from "../../helpers";
import CustomSelect from "./CustomSelect";
import {
  allSensorParameters,
  allSensors,
  allGrains,
  getFirstSensorId,
  getFirstSensorPrameterId,
  getFirstlGrainId,
} from "../../selector/common";
import { commonConstants } from "../../constants";
import { isEmpty } from "lodash";

const GlobalSearch = ({
  getData,
  allGrains,
  allSensors,
  allSensorParameters,
  values,
  manualRefresh,
  manualRefreshHandler,
  setFilterData,
  showFilters = [],
  placeholder,
  loading,
  isDownload,
  ...props
}) => {
  const [searchData, setSearchData] = useState(null);
  const [grainOptions, setGrainOptions] = useState([]);

  /* const handleSearch = useCallback(() => {
    let filterData = removeEmptyObjects(searchData);
    updateGrainOptions(filterData);
    //setFilterData();
    getData && getData(filterData);
    //setSearchData((prevData) => ({ ...prevData, is_download: false }));
  }, [searchData, getData]); */

  useEffect(() => {
    if (isEmpty(allGrains)) return;
    if (isEmpty(allSensorParameters)) return;

    const sensorId = (
      values?.sensor_id ? values.sensor_id : getFirstSensorId(allSensors)
    ).toString();
    const sensorParameters = getSelectedSensorParameters(sensorId, allSensors, allSensorParameters);

    const initialValues = {
      daterange: values?.daterange
        ? Object.keys(getDateRanges()).includes(values.daterange)
          ? getTimeStampFromDateRange(values.daterange)
          : values.daterange
        : {},
      sensor_id: sensorId,
      parameter_id: (values?.parameter_id
        ? values.parameter_id
        : getFirstSensorPrameterId(sensorParameters)
      ).toString(),
      grain: values?.grain ? values.grain : getFirstlGrainId(allGrains, 1),
    };

    setSearchData(initialValues);
    //handleSearch();
  }, [allSensors, allSensorParameters, allGrains]);

  useEffect(() => {
    if (isEmpty(searchData)) return;
    let filterData = removeEmptyObjects(searchData);

    //console.log("======searchData=", filterData);
    updateGrainOptions(filterData);
    setFilterData && setFilterData(filterData);
    getData && getData(filterData);
  }, [searchData]);

  useEffect(() => {
    if (!loading && manualRefresh) {
      manualRefreshHandler(false);
    }
  }, [loading, manualRefresh, manualRefreshHandler]);

  useEffect(() => {
    if (manualRefresh) {
      getData(searchData);
    }
  }, [manualRefresh, searchData, getData]);

  const applyAdvanceSearch = (data) => {
    if (data) {
      setSearchData(data);
    }
  };

  /* const setFilterData = () => {
    setFilterData && setFilterData(searchData);
  }; */

  const updateGrainOptions = () => {
    const allGrainsCopy = { ...allGrains };
    if (searchData?.daterange?.to - searchData?.daterange?.from > 24 * 60 * 60) {
      if (searchData.grain === commonConstants.grain.UNAGGREEGATED) {
        searchData.grain = commonConstants.grain.MIN15;
      }
      delete allGrainsCopy[0];
    }
    setGrainOptions(convertToOptions(allGrainsCopy, "id", "label"));
  };
  return (
    <div className="search-bar mb-0">
      {searchData && (
        <Formik
          enableReinitialize={true}
          initialValues={searchData}
          onSubmit={(values) => {
            applyAdvanceSearch(values);
          }}
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              handleBlur,
              handleSubmit,
              submitCount,
              setFieldValue,
            } = props;
            const sensorParameters = getSelectedSensorParameters(
              values.sensor_id,
              allSensors,
              allSensorParameters
            );
            return (
              <form
                onSubmit={handleSubmit}
                className={`needs-validation${submitCount ? " was-validated1" : ""}`}
              >
                {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                <Row>
                  {showFilters.includes("date") && (
                    <Col sm="12" md="6" lg="6" xl="4" className="mt-2">
                      <SelectCalendarFilter
                        name="daterange"
                        label="Date Range"
                        placeholder={placeholder?.daterange || "Select Date"}
                        value={values?.daterange}
                        onBlur={handleBlur}
                        errors={errors}
                        touched={touched}
                        setFieldValue={setFieldValue}
                        onDateChange={handleSubmit}
                        labelwidth={12}
                        inputwidth={12}
                      />
                    </Col>
                  )}

                  {showFilters.includes("sensors") && (
                    <Col sm="12" md="4" lg="4" xl="2">
                      <FieldRenderer
                        as={CustomSelect}
                        label="Sensors"
                        name={"sensor_id"}
                        options={convertToOptions(allSensors, "sensor_id", "title")}
                        value={values.sensor_id}
                        onChange={(value) => {
                          const newSensorParameters = getSelectedSensorParameters(
                            value,
                            allSensors,
                            allSensorParameters
                          );
                          const isParameterExists = newSensorParameters.some(
                            (sensor) =>
                              parseInt(sensor.parameter_id) === parseInt(values.parameter_id)
                          );
                          if (!isParameterExists) {
                            setFieldValue(
                              "parameter_id",
                              getFirstSensorPrameterId(newSensorParameters)
                            );
                          }
                          setFieldValue("sensor_id", value);
                          handleSubmit();
                        }}
                        labelwidth={12}
                        inputwidth={12}
                      />
                    </Col>
                  )}
                  {showFilters.includes("parameters") && (
                    <Col sm="12" md="4" lg="4" xl="3">
                      <FieldRenderer
                        as={CustomSelect}
                        label="Parameters"
                        name={"parameter_id"}
                        options={convertToOptions(sensorParameters, "parameter_id", "title")}
                        value={values.parameter_id}
                        onChange={(value) => {
                          setFieldValue("parameter_id", value);
                          handleSubmit();
                        }}
                        labelwidth={12}
                        inputwidth={12}
                      />
                    </Col>
                  )}
                  {showFilters.includes("grain") && (
                    <Col sm="12" md="6" lg="6" xl="2">
                      <FieldRenderer
                        as={CustomSelect}
                        label="Grain"
                        name={"grain"}
                        options={grainOptions}
                        value={values.grain}
                        onChange={(value) => {
                          setFieldValue("grain", value);
                          handleSubmit();
                        }}
                        labelwidth={12}
                        inputwidth={12}
                      />
                    </Col>
                  )}
                  {isDownload && (
                    <Col sm="12" md="6" lg="6" xl="2" className="mt-3">
                      <Button
                        type="submit"
                        disabled={loading}
                        className="ml-2 mt-3"
                        onClick={(e) => {
                          setFieldValue("is_download", true);
                        }}
                      >
                        Download Excel
                      </Button>
                    </Col>
                  )}
                </Row>
              </form>
            );
          }}
        </Formik>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  allGrains: allGrains(state),
  allSensors: allSensors(state),
  allSensorParameters: allSensorParameters(state),
});

export default connect(mapStateToProps)(GlobalSearch);
